import { useState, useEffect, useCallback, useRef } from 'react';

let globalAddress = '';
let listeners = [];

export const useSharedAddress = () => {
    const [address, setAddress] = useState(globalAddress);
    const isSettingRef = useRef(false);

    const setGlobalAddress = useCallback((newValue) => {
        if (newValue !== globalAddress && !isSettingRef.current) {
            isSettingRef.current = true;
            globalAddress = newValue;
            listeners.forEach(listener => {
                if (listener.current !== newValue) {
                    listener(newValue);
                }
            });
            isSettingRef.current = false;
        }
    }, []);

    useEffect(() => {
        const listener = (newAddress) => {
            setAddress(newAddress);
        };

        listeners.push(listener);
        return () => {
            listeners = listeners.filter(l => l !== listener);
        };
    }, []);

    return [address, setGlobalAddress];
};
